// frontend/src/config.js

// Конфигурация API

// Переменная API_BASE_URL и isDevelopment нужны только для ЛОКАЛЬНОЙ разработки.
// В продакшен-сборке они фактически не влияют на getApiUrl.
const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
// Оставляем для локальной разработки, если понадобится
export const API_BASE_URL_DEV_ONLY = isDevelopment
    ? 'http://127.0.0.1:8000'
    : ''; // В проде НЕ используется функцией getApiUrl

// FRONTEND_URL для продакшена
export const FRONTEND_URL = isDevelopment
    ? 'http://localhost:3000' // Локальный сервер React
    : 'https://app.vincle.ru'; // Боевой сервер

// --- ИСПРАВЛЕНО ---
// Функция для получения URL API. В продакшене ВСЕГДА возвращает относительный путь.
export const getApiUrl = (path) => {
    // В режиме разработки можно использовать абсолютный URL для удобства
    if (isDevelopment) {
        const base = 'http://127.0.0.1:8000'; // Локальный Django
        if (!path) return base;
        return path.startsWith('http') ? path : `${base}${path.startsWith('/') ? path : `/${path}`}`;
    }

    // В продакшене ВСЕГДА используем относительный путь от корня домена
    if (!path) {
        return ''; // Или можно вернуть '/', если это требуется
    }
    // Если путь уже начинается со слеша (например, '/api/users'), используем его как есть
    if (path.startsWith('/')) {
        return path;
    }
    // Если путь не начинается со слеша (например, 'api/users'), добавляем слеш
    // console.log(`getApiUrl (prod): Преобразование относительного пути ${path} в /${path}`);
    return `/${path}`;
};

// Функция для проверки, запущено ли приложение в Telegram WebApp
export const isTelegramWebApp = () => {
    // Проверяем наличие объекта и его свойств безопасно
    return typeof window !== 'undefined' && window.Telegram && typeof window.Telegram.WebApp !== 'undefined';
};

// Функция для оптимизации ввода в Telegram WebApp
export const optimizeWebAppInput = (element) => {
    if (!isTelegramWebApp()) return;

    // Программно вызываем клавиатуру через blur/focus
    if (element && typeof element.blur === 'function' && typeof element.focus === 'function') {
        try {
            element.blur();
            setTimeout(() => {
                element.focus();
            }, 100); // Небольшая задержка может помочь
        } catch (e) {
            console.error("Ошибка при попытке оптимизировать ввод:", e);
        }
    } else {
        console.warn("optimizeWebAppInput: Передан невалидный элемент или функции focus/blur отсутствуют.");
    }
};